import { HeaderWrapperSliceState } from './store';

export const selectCurrentHeight = (state: { headerWrapper: HeaderWrapperSliceState }) => {
    return state.headerWrapper.currentHeight;
};
